<template>
  <div class="login-form">
    <div
      class="title free-tip-topLeft"
      :data-tip="$t('zhu-ce-li-xiang-7-tian-mian-fei-shi-yong')"
    >
      {{ $t('huan-ying-deng-lu-you-yan-fu-wu-ping-tai') }}
    </div>

    <div class="mt-[15px] text-[14px] h-[22px] text-font-80">
      <span v-if="activeKey === 'login'">
        {{ $t('mei-you-zhang-hao') }}&nbsp;
        <a class="cursor-pointer font-500" @click="onToggleKey">
          {{ $t('li-ji-zhu-ce') }}
        </a>
      </span>
      <span v-if="activeKey === 'register'">
        {{ $t('yi-you-zhang-hao') }}
        &nbsp;
        <a class="cursor-pointer font-500" @click="onToggleKey">
          {{ $t('li-ji-deng-lu') }}
        </a>
      </span>
    </div>
    <a-form
      :model="formState"
      name="basic"
      :label-col="{ span: 0 }"
      :wrapper-col="{ span: 24 }"
      autocomplete="off"
      class="mt-[50px] w-[420px] sea-form"
      @finish="onFinish"
      @finishFailed="onFinishFailed"
    >
      <template v-if="activeKey === 'register'">
        <a-form-item
          name="email"
          :rules="[
            { required: true, message: $t('qing-shu-ru-you-xiang') },
            {
              pattern: emailReg,
              message: $t('qing-shu-ru-zheng-que-de-you-xiang-ge-shi'),
              trigger: 'blur',
            },
          ]"
        >
          <a-input
            v-model:value="formState.email"
            class="yy-input-xlg"
            :placeholder="$t('qing-shu-ru-you-xiang')"
          />
        </a-form-item>
        <a-form-item
          name="sms_code"
          :rules="[
            { required: true, message: $t('qing-shu-ru-yan-zheng-ma') },
            {
              pattern: smsCodeReg,
              message: $t('6-wei-shu-zi-yan-zheng-ma'),
              trigger: 'blur',
            },
          ]"
        >
          <XCaptchaInput
            v-model:value="formState.sms_code"
            :placeholder="$t('qing-shu-ru-yan-zheng-ma')"
            :xLarge="true"
            :data="formState.email"
            :is-checked="formState.remember"
            type="primary"
          />
        </a-form-item>
        <a-form-item
          name="password"
          auto-complete="off"
          :help="false"
          :rules="[
            {
              validator: PwdValidator.validateNewPassword,
              trigger: ['change', 'blur'],
            },
          ]"
        >
          <a-input-password
            v-model:value="formState.password"
            class="mb-[5px]"
            size="large"
            :placeholder="$t('xin-mi-ma')"
          />
          <div
            :class="{
              'pwd-rule-tip': true,
              success: PwdValidator.isSafeRange(formState.password),
            }"
          >
            <iconpark-icon name="circle-check"></iconpark-icon>
            {{ $t('chang-du-wei-620-ge-zi-fu') }}
          </div>
          <div
            :class="{
              'pwd-rule-tip': true,
              success: PwdValidator.isValidFormat(formState.password),
            }"
          >
            <iconpark-icon name="circle-check"></iconpark-icon>
            {{
              $t(
                'bao-han-shu-zi-da-xie-zi-mu-xiao-xie-zi-fu-zi-fu-san-zhong-ji-yi-shang'
              )
            }}
          </div>
        </a-form-item>
        <a-form-item
          name="checkPassword"
          autoComplete="off"
          :rules="[
            {
              required: true,
              validator: (_rule, value) =>
                validatePassword(_rule, value, formState.password),
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <a-input-password
            v-model:value="formState.checkPassword"
            size="large"
            class="yy-input-xlg"
            :placeholder="$t('qing-que-ren-mi-ma')"
            autoComplete="new-password"
          />
        </a-form-item>
      </template>
      <div v-if="activeKey === 'login'" class="relative">
        <a-form-item
          name="email"
          :rules="[
            {
              required: true,
              message: $t('qing-shu-ru-you-xiang'),
              trigger: 'blur',
            },
            {
              pattern: emailReg,
              message: $t('qing-shu-ru-zheng-que-de-you-xiang-ge-shi'),
              trigger: 'blur',
            },
          ]"
        >
          <a-input
            v-model:value="formState.email"
            class="yy-input-xlg"
            :placeholder="$t('qing-shu-ru-you-xiang')"
          />
        </a-form-item>
        <a-form-item
          name="password"
          :rules="[
            { required: true, message: $t('qing-shu-ru-mi-ma') },
            {
              pattern: legacyPasswordReg,
              message: $t('620-wei-ren-yi-shu-zi-zi-mu-te-shu-fu-hao'),
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <a-input-password
            v-model:value="formState.password"
            class="yy-input-xlg"
            :placeholder="$t('qing-shu-ru-mi-ma')"
          />
        </a-form-item>
        <a
          class="absolute top-[138px] right-0 text-[13px]"
          @click="onOpenReset"
        >
          {{ $t('wang-ji-mi-ma') }}
        </a>
      </div>
      <a-form-item :wrapper-col="{ offset: 0, span: 24 }" class="!mt-[80px]">
        <a-button
          type="primary"
          :disabled="!canSubmit"
          html-type="submit"
          :loading="loading"
          class="yy-btn-xlg btn-shadow"
        >
          {{ activeKey === 'login' ? $t('deng-lu') : $t('zhu-ce') }}
        </a-button>
      </a-form-item>
      <a-form-item
        v-if="!isChinese()"
        :wrapper-col="{ offset: 0, span: 24 }"
        class="-mt-[8px]"
      >
        <div class="or">{{ $t('or-continue-with') }}</div>
        <GoogleLogin
          class="google-login-btn yy-btn-xlg my-[20px] w-[420px]"
          :disabled="!formState.remember"
          @success="handleGoogleLoginSuccess"
        />
      </a-form-item>
      <a-form-item
        name="remember"
        class="mt-[35px]"
        :wrapper-col="{ offset: 0, span: 24 }"
      >
        {{
          $t('by-signing-up-to-the-platform-you-understand-and-agree-to-our')
        }}
        <ALink
          :href="
            !isChinese()
              ? 'https://protocol.rendora.ai/legal/user'
              : 'https://frontend-protocol.xmov.ai/youyan-v3/user'
          "
          name="user"
        >
          {{ $t('mo-fa-you-yan-yong-hu-xie-yi') }}
        </ALink>
        {{ $t('huo') }}
        <ALink
          :href="
            !isChinese()
              ? 'https://protocol.rendora.ai/legal/privacy-policy'
              : 'https://frontend-protocol.xmov.ai/youyan-v3/privacy'
          "
          name="policy"
        >
          {{ $t('mo-fa-you-yan-yin-si-zheng-ce') }}
        </ALink>
      </a-form-item>
    </a-form>
    <ProtocolConfirm v-model:open="confirmProtocolOpen" @confirm="confirm" />
  </div>
</template>
<script lang="ts" setup>
import GoogleLogin from './googleLogin.vue'
import ProtocolConfirm from './protocolConfirm.vue'
import { trackData } from './trackData'
import { getUserInfo, registerByEmail, loginByEmail } from '@/api'
import {
  BROADCAST_KEY,
  COOKIE_KEY,
  INVITE_CODE,
  SESSION_REF,
  SESSION_SOURCE,
} from '~/constants/config'
import type { LoginInfo } from '~/api/interface'
import { getLocation } from '~/api/module/seo'
import { useTime } from '~/hooks/useTime'
import { ServerErrorCode } from '~/api/request'
import { legacyPasswordReg } from '~/utils/form'

const { $t } = useNuxtApp()
const confirmProtocolOpen = ref(false)

interface FormState {
  email: string
  // email: string
  checkPassword: string
  sms_code: string
  password: string
  remember: boolean
}

interface IPublicKeyPayload {
  email: string
  password: string
  verify_code?: string
}

interface IPublicKeyInfo {
  id: number
  public_key: string
}

const formState = reactive<FormState>({
  email: '',
  sms_code: '',
  password: '',
  checkPassword: '',
  remember: true,
})
const { setAccountList, setSession, setUserInfo } = useChangeUser()
const loading = ref(false)
const route = useRoute()
const emits = defineEmits(['back', 'success', 'accountSelect'])

type LoginType = 'register' | 'login'

const activeKey = ref<LoginType>('login')

const onToggleKey = () => {
  trackEvent(TRACK_EVENT.YOUYAN_LOGIN_CLICK_REGISTER)
  // changeKey('register')
  activeKey.value = activeKey.value !== 'login' ? 'login' : 'register'
}

const canSubmit = computed(() => {
  if (activeKey.value === 'register') {
    return formState.sms_code && formState.email
  }

  return formState.password && formState.email
})

const confirm = async () => {
  confirmProtocolOpen.value = false
  formState.remember = true
  await onFinish(toRaw(formState))
}

// 打开忘记密码
const onOpenReset = () => {
  trackEvent(TRACK_EVENT.CLICK_LOGIN_FORGET_BTN)
  emits('back')
}

const { $dayjs } = useTime()

const handleGoogleLoginSuccess = async (data: LoginInfo[]) => {
  sensorsRegisterPage(data[0])

  const newUser = $dayjs().isSame($dayjs(data[0]?.create_time), 'day')

  trackData(
    'google',
    { email: data[0]?.email_address },
    {
      NewUser: newUser ? USER_TYPE.NEW : USER_TYPE.OLD,
      LoginWay: LOGIN_WAY.GOOGLE,
    }
  )

  if (data.length > 1) {
    // 用户账号列表
    setAccountList(data)
    emits('accountSelect', data)
  } else {
    // 用户token
    await setSession(data[0])
    // emitBroadcast(COOKIE_KEY.USER_TOKEN, {
    //   cookieValue: data[0],
    // })
    emitBroadcast(BROADCAST_KEY.REFRESH, { tabId: TAB_ID })
    sensorsLogin(data[0]?.user_id)
    const result = await getUserInfo()

    // 用户信息
    await setUserInfo(result.data as any)

    emits('success', result.data)
  }
}

const onFinish = async (values: any) => {
  if (!formState.remember) {
    // message.warning($t('qing-xian-yue-du-bing-gou-xuan-tiao-kuan'))
    confirmProtocolOpen.value = true
    return
  }
  loading.value = true

  try {
    let res

    const source = sessionGetItem(SESSION_SOURCE) || undefined // 第三方来源注册
    const linkCode = sessionGetItem(INVITE_CODE) || undefined // 邀请码注册

    const utm_source = route.query?.utm_source as string
    const utm_medium = route.query?.utm_medium as string
    const utm_campaign = route.query?.utm_campaign as string
    const utm_content = route.query?.utm_content as string
    const utm_term =
      route.query?.utm_term || (sessionGetItem(SESSION_REF) as string)
    const keyword_search = route.query?.keyword_search as string
    const gclid = route.query?.gclid as string

    let newUser = false

    if (activeKey.value === 'register') {
      newUser = true
      const [res1, res2] = await concurrency([
        transformPublicKey({
          email: values.email,
          password: values.password,
          verify_code: values.sms_code,
        }),
        getLocation(),
      ])

      const [encrypted, rsa] = res1!

      res = await registerByEmail({
        rsa_key_id: rsa?.id,
        auth_data: encrypted,
        link_code: linkCode || undefined,
        ...redirectQueryPPT(route.query?.redirect as string),
        source,
        utm_campaign,
        utm_content,
        utm_medium,
        utm_source,
        utm_term,
        keyword_search,
        gclid,
        country: res2.country,
      })

      if (linkCode) {
        sessionGetItem(INVITE_CODE)
      }
    } else {
      newUser = false
      const [res1, res2] = await concurrency([
        transformPublicKey({
          email: values.email,
          password: values.password,
        }),
        getLocation(),
      ])

      const [encrypted, rsa] = res1

      res = await loginByEmail({
        rsa_key_id: rsa?.id,
        auth_data: encrypted,
        source,
        country: res2.country,
        utm_campaign,
        utm_content,
        utm_medium,
        utm_source,
        utm_term,
        keyword_search,
        gclid,
      })

      if (
        [
          ServerErrorCode.USER_EXIST_ERROR,
          ServerErrorCode.EMAIL_NOT_REGISTERED,
        ].includes(res.code)
      ) {
        activeKey.value = 'register'
        message.error(res.msg)
        throw new Error(res.msg)
      }

      if (linkCode) {
        sessionGetItem(INVITE_CODE)
      }
    }

    if (res.data) {
      const { data } = res

      sensorsRegisterPage(data[0])

      // 用户账号列表
      setAccountList(data)

      trackData(
        'google',
        { email: values.email },
        {
          LoginWay: LOGIN_WAY.EMAIL,
          NewUser: newUser ? USER_TYPE.NEW : USER_TYPE.OLD,
          // InviterId: res.data[0]?.invitation_info?.user_id || undefined,
        }
      )

      if (data.length > 1) {
        emits('accountSelect', data)
      } else {
        // 用户token
        await setSession(res.data[0])
        // emitBroadcast(COOKIE_KEY.USER_TOKEN, {
        //   cookieValue: res.data[0],
        // })
        emitBroadcast(BROADCAST_KEY.REFRESH, { tabId: TAB_ID })
        sensorsLogin(res.data[0]?.user_id)
        const result = await getUserInfo()

        // 用户信息
        setUserInfo(result.data as any)

        emits('success', result.data)
      }
      sessionRemoveItem(SESSION_SOURCE)

      loading.value = false
    }
  } catch (error) {
    console.log(error)
    loading.value = false
  }
}

const onFinishFailed = (errorInfo: any) => {
  // console.log('Failed:', errorInfo)
}
</script>

<style lang="scss" scoped>
.login-form {
  .title {
    @apply font-medium text-[36px];
  }
  .ant-form-item {
    margin-bottom: 30px;
  }

  :deep(.ant-tabs) {
    @apply text-font-70;
    .ant-tabs-tab {
      @apply text-[16px] px-[19px];
    }
    .ant-tabs-tab-active .ant-tabs-tab-btn {
      @apply text-font-1;
    }
  }

  .login-btn {
    @apply bg-back-3 text-font-60 flex w-[300px] rounded-[8px] p-[2px] mx-auto;

    .btn-item {
      @apply w-[150px] text-center rounded-[8px] cursor-pointer;
      padding: 12px 16px;

      &.active {
        @apply text-font-1 bg-back-1 font-medium;
      }
    }
  }

  .btn-shadow {
    @apply w-full;
    box-shadow: 0px 36px 36px -20px rgba(105, 98, 255, 0.8);
  }
}
.or {
  font-size: 13px;
  color: var(--text-1-70);
  line-height: 18px;
  text-align: center;
  width: 100%;
}
.google-login-btn {
  height: 48px;
  box-shadow: none !important;
}
.sea-form {
  .ant-form-item {
    margin-bottom: 26px;
  }
}
.font-500 {
  font-weight: 500;
}
</style>
<style lang="scss" scoped>
.pwd-rule-tip {
  display: flex;
  align-items: center;
  margin-top: 2px;
  iconpark-icon {
    color: #cacdda;
    margin-right: 5px;
  }
  &.success iconpark-icon {
    color: #29e69c;
  }
}
</style>
